import { notification } from 'ant-design-vue'
import { MESSAGE_ERROR } from '@/utils/constants';

export function uuidv4() {
    return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
      (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
    );
  }

export const isEmpty = (value: any) => value == undefined || value == null || !(Object.keys(value) || value).length;



export const openNotificationWithIcon = (type: string, message: string, description?: string) => {
  description ??= MESSAGE_ERROR;
    notification[type]({
        message,
        description,
    });
};

export const decodeJwt = (token: string) => {
  const payloadIndex = 1;
  const result = JSON.parse(atob(token.split('.')[payloadIndex]))
  return result;
};

export const openNotificationSuccess = (message: string = "La operación fue realizada exitosamente.") => {
  openNotificationWithIcon("success", "Éxito", message)
}

export const openNotificationError = (message: any = undefined) => {
  openNotificationWithIcon("error", "Error", message)
}
export const preparedFilter = (filters: Array<string | Array<string|number>>) => {
  let result: string = "";
  result = JSON.stringify(filters);
  return result;
}

export const normalizeProperties = (values: [key: any]) => {
  for (let property in values) {
    let value = values[property]
    if (typeof value === "string") {
      values[property] = value.toUpperCase().replace(/\s{2,}/g, ' ').trim()
    }
  }
  return values;
}